export class FrontendScriptOutlineItem {

    sortName = "";
    scope = "";
    parents: string[] = [];
    searchRegex: string;

    constructor(public id: string, public type: string, public name: string, props: Partial<FrontendScriptOutlineItem>) {
        if (props != null) {
            Object.assign(this, props);
        }
    }
    
    getSortName(): string {
        return this.sortName ?? this.name;
    }
}
